import React from 'react'

import Main from './components/Main.jsx'

export default props => (
    <div className="App">
        <Main />
    </div>
);